export const PARTICIPANT_IDENTITY_FIELDS = 'name avatarUrl avatarVersion profileUrl affiliation';
export const TEAM_IDENTITY_FIELDS =
  'name profileUrl affiliation memberCount members { name avatarUrl avatarVersion profileUrl isCaptain }';
